import React, {Component} from "react"
import {Button} from "semantic-ui-react"
import shop from "shop/shop"
import requestPassword from "components/Account/requestPassword"


export default class AccountReset extends Component {

  request = () => {
    const { email } = this.props
    console.log( `request PW RESET`, email, shop )
    requestPassword({email, shop})
  }

  render() {
    return <Button onClick={this.request} color="red">{translate( "change Password" )}</Button>
  }
}



// WEBPACK FOOTER //
// ./src/components/Account/AccountReset.js